import {getContacts} from "@/webservice/webservice";

export default {
    name : 'ContactSearcher',
    props: ['value'],
    data: function () {
        return {
            count: 0,
            showDialog: false,
            txtSearch: "",
            contactName: "",
            contacts: []
        }
    },
    methods: {
        openDialog() {
            this.showDialog = true;
        },
        closeDialog() {
            this.showDialog = false;
        },
        selectContact(contact){
            this.$emit('input', contact.contact_id);
            this.showDialog = false;
        },
        getContactName(val){
            if(val != "") {
                const req = {
                    "start": 0,
                    "limit": 100,
                    "sort": "contact_id",
                    "order": "asc",
                    "filter": {contact_id: val}
                };
                this.$http.post(this.$hostname + 'contacts/getlist', JSON.stringify(req), {
                    headers: {
                        "metoken": localStorage.getItem('token')
                    }
                }).then((resp) => {
                    if (resp.status === 200) {
                        let contacts = resp.body.list;
                        if (contacts.length > 0) {
                            this.contactName = contacts[0].name + ' ' + contacts[0].family;
                        }
                    }
                })
            }else{
                this.contactName = "";
            }
        }
    },
    watch: {
        'txtSearch': {
            handler(value) {
                if(value.length > 2) {

                    this.$http.post(this.$hostname + 'contacts/autocomplete', JSON.stringify({"keyword":value}), {
                        headers: {
                            "metoken": localStorage.getItem('token')
                        }
                    }).then((resp) => {
                        if (resp.status === 200) {
                            this.contacts = resp.body;
                        }
                    })
                }
            },
            deep: true,
        },
        value (val) {
            this.getContactName(val);
        }
    },
    template:`
      <div style="display: inline;">

          <div class="v-dialog v-dialog--active" style="transform-origin: center center 0px; max-width: 300px;position: absolute;top: 30px;border:1px solid black;background: white;padding: 20px;z-index:50;" v-if="showDialog">
            <input type="text" v-model="txtSearch" class="form-control" >

            <ul role="list-items" class="list-group">
              <a  v-for="contact in this.contacts" v-on:click="selectContact(contact)" class="list-group-item list-group-item-action " style="cursor: pointer;">{{ contact.contact_id }} :: {{ contact.name }} {{ contact.family }}</a>
            </ul>

            <button class="btn mb-2 ml-2 text-white btn-primary" v-on:click="closeDialog" style="margin-top:10px;">انصراف</button>
          </div>

          <button v-on:click="openDialog" type="button" aria-label="prepend icon" class="v-icon notranslate v-icon--link mdi mdi-magnify theme--light" style="display: inline;"></button>
          <label>{{ contactName }}</label>
      </div>        
      `


}